import { AlertRow } from '@components/AlertCenter/AlertRows/AlertRow';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { useNavigate } from 'react-router-dom';
import { useGetLead } from '@services/api/leads/lead-info';
import { mdiFileOutline } from '@mdi/js';
import { MdiIconWrapper } from '@components/MdiIconWrapper';
import { useQueryParamsModal } from '@utils/navigation/queryParamsNavigation';

type MissingMaterialAlertRowProps = {
  leadId: number;
};

export const MissingMaterialAlertRow = ({ leadId }: MissingMaterialAlertRowProps) => {
  const {
    translate,
    translateWithParams,
    translations: {
      alertCenter: { inbox },
    },
  } = useTranslations();

  const { closeModal } = useQueryParamsModal(`alerts`);
  const { lead } = useGetLead({ leadId });

  const navigate = useNavigate();

  const goToProfile = () => {
    closeModal();
    navigate(`/leads/${leadId}/project`);
  };

  return (
    <AlertRow
      Icon={<MdiIconWrapper path={mdiFileOutline} />}
      title={translate(inbox.missingMaterial.title)}
      actionText={translateWithParams(inbox.missingMaterial.path)(lead?.address.street ?? lead?.address.city ?? ``)}
      subtitle={translate(inbox.subtitle)}
      action={goToProfile}
    />
  );
};
